import React, { FC, useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import CModal from "../../../components/modal";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import IrancellIcon from "../../../assets/images/irancell-icon.svg";
import HamrahAvalIcon from "../../../assets/images/hamrahAvalIcon.svg";
import RightelIcon from "../../../assets/images/rightelIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../redux";
import {
  FetchInternetPackage,
  FetchModal,
} from "../../../redux/internetPackage/actions";
import { RialSeparator } from "../../../utils/price-separator";
import { SetChargePackage } from "../../../redux/chargePackage/actions";
import { opratorSelector } from "../../../utils/opratorSelector";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import CustomInputNumber from "../../../components/input-number";

const InternetView = () => {
  const { access_token } = useSelector(
    ({ authorization }: ApplicationState) => authorization
  );
  const [modalStyle] = useState(getModalStyle);
  const [formValue, setFormValue] = useState<any>({
    mobile_number: undefined,
    operator_id: undefined,
    package_type_id: undefined,
  });
  const [formErr, setFormErr] = useState<any>({});
  const [filtered, setFiltered] = useState<any>(undefined);
  const [redirect, setRedirect] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    internetPackage,
  } = useSelector(({ internet }: any) => internet);

  let type: any;
  switch (formValue["package_type_id"]) {
    case 1:
      type = "اعتباری";
      break;
    case 2:
      type = "دائمی";
      break;
    default:
  }

  useEffect(() => {
    let op = opratorSelector(formValue["mobile_number"]);
    setFormValue({
      ...formValue,
      operator_id: op,
    });
  }, [formValue["mobile_number"]]);

  const handleFormValue = ({ target: { name, value } }: any) => {
    setFormValue({
      ...formValue,
      [name]: value,
    });
  };

  const handleButton = (name: string, value: any) => {
    setFormValue({
      ...formValue,
      [name]: value,
    });
  };

  const validate = (submit: any) => {
    let _errors = {};
    let hasError = false;
    Object.keys(formValue).map((item: any) => {
      // @ts-ignore
      if (!formValue[item]) {
        _errors = { ..._errors, [item]: "این فیلداجباری است" };
        hasError = true;
      } else if (formValue["mobile_number"]?.slice(0, 2) !== "09") {
        _errors = {
          ..._errors,
          ["mobile_number"]: "شماره موبایل باید با 09 شروع شود",
        };
        hasError = true;
      } else if (formValue["mobile_number"]?.length !== 11) {
        _errors = {
          ..._errors,
          ["mobile_number"]: "شماره موبایل باید 11 رقم باشد",
        };
        hasError = true;
      }
    });
    setFormErr(_errors);
    if (!hasError) submit();
  };

  function rand() {
    return Math.round(Math.random() * 20) - 10;
  }

  function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const handlePackage = () => {
    if (info.package_id) {
      console.log("redirect");
      setRedirect(true);
    } else {
      toast.error("بسته مورد نظر خود را انتخاب کنید");
    }
  };

  const { modal } = useSelector(({ internet }: any) => internet);

  const handleClose = () => {
    dispatch(FetchModal(false));
  };

  useEffect(() => {
    if (formValue["operator_id"] == 2) {
      setFormValue({
        ...formValue,
        ["package_type_id"]: 2,
      });
    }
  }, [formValue["operator_id"]]);

  useEffect(() => {
    dispatch(FetchModal(false));
    dispatch(SetChargePackage({}))
  }, []);

  const handleSubmit = () => {
    if (access_token == "") {
      toast.error("مشکل اعتبار سنجی");
    } else {
      dispatch(FetchInternetPackage(formValue));
      dispatch(SetChargePackage(formValue));
    }
  };

  const handleChange = ({ target: { value } }: any) => {
    setFiltered(value);
  };

  const { info } = useSelector(({ payment }: any) => payment);

  const handleChoose = (pack: any) => {
    dispatch(
      SetChargePackage({
        package_id: pack.package_id,
        package_title: pack.title,
        amount: pack.bill_amount,
        mobile_number: formValue["mobile_number"],
        type_operator_id: formValue["operator_id"],
        type_simcard_id: formValue["package_type_id"],
        package_type_id: parseInt(pack.package_type),
        package_type_title: pack.title_package_type,
      })
    );
  };

  const valid = ({ target: { name, value } }: any) => {
    let event = {
      target: {
        name: name,
        value: value,
      },
    };
    switch (name) {
      case "mobile_number":
        if (value.length < 12) {
          handleFormValue(event);
        }
        break;
      default:
        handleFormValue(event);
    }
  };

  const filter = (data: any) => {
    setFiltered(data);
  };

  const packs = internetPackage?.Packages?.filter((pack: any) =>
    filtered ? filtered.includes(pack.duration_package_id) : pack
  ).map((all: any) => all.content);

  const allPacks = [].concat.apply([], packs);

  const arrayEquals = (a: any, b: any) => {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index])
    );
  };

  if (redirect) {
    history.push("/payment");
  }

  return (
    // @ts-ignore
    <Box className="dir box mainBox p-res" p={6}>
      <Grid container>
        <Grid item xs={12}>
          {/* @ts-ignore */}
          <Box display="flex" alignItems="center">
            <Typography
              className="text-muted text-right small"
              style={{ width: "25%", whiteSpace: 'nowrap', marginLeft: '5px' }}
            >
              شماره موبایل
            </Typography>
            <CustomInputNumber
              placeholder="09"
              type={"number"}
              name="mobile_number"
              variant="outlined"
              className="w-100 my-3"
              size="small"
              onChange={valid}
              autocomplete={"on"}
              value={formValue["mobile_number"]}
              dir="rtl"
            />
          </Box>

          <Typography className="textError">
            {formErr && formErr["mobile_number"]}
          </Typography>
        </Grid>

      </Grid>
      <Grid container className="m-0" style={{ marginBottom: '5px', flexWrap: 'nowrap' }}>
        <Grid item>
          <InfoOutlinedIcon color="secondary" className="resize ml-2" />
        </Grid>
        <Grid item justifyContent="flex-end">
          <Typography className="small text-muted">
            در صورتی که ترابرد کرده اید اپراتور خود را تغییر دهید
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={3} className="op-res">
          {/* @ts-ignore */}
          <Box p={1} display="flex" justifyContent="center" className="flexi">
            <Button
              variant="contained"
              className={`btn ${formValue["operator_id"] === 1 ? "Active" : ""
                } btn-res`}
              onClick={() => handleButton("operator_id", 1)}
            >
              <img src={IrancellIcon} width="60px" className="img-res" />
            </Button>
          </Box>
        </Grid>
        <Grid item xs={3} className="op-res">
          {/* @ts-ignore */}
          <Box p={1} display="flex" justifyContent="center" className="flexi">
            <Button
              variant="contained"
              className={`btn ${formValue["operator_id"] === 2 ? "Active" : ""
                } btn-res`}
              onClick={() => handleButton("operator_id", 2)}
            >
              <img src={HamrahAvalIcon} width="60px" className="img-res" />
            </Button>
          </Box>
        </Grid>
        <Grid item xs={3} className="op-res">
          {/* @ts-ignore */}
          <Box p={1} display="flex" justifyContent="center" className="flexi">
            <Button
              variant="contained"
              className={`btn ${formValue["operator_id"] === 3 ? "Active" : ""
                } btn-res`}
              onClick={() => handleButton("operator_id", 3)}
            >
              <img src={RightelIcon} width="60px" className="img-res" />
            </Button>
          </Box>
        </Grid>
        {formErr["operator_id"] && <Grid item xs={12}>
          <Typography className="textError">
            {formErr["operator_id"]}
          </Typography>
        </Grid>}
      </Grid>

      {formValue["operator_id"] != 2 && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Typography className="text-muted">نوع سیم کارت:</Typography>
          </Grid>
          <Grid item xs={6} md={4}>
            <Button
              variant="contained"
              className="w-100 round"
              color={formValue["package_type_id"] === 1 ? "primary" : "inherit"}
              size="small"
              onClick={() => handleButton("package_type_id", 1)}
            >
              اعتباری
            </Button>
          </Grid>
          <Grid item xs={6} md={4}>
            <Button
              variant="contained"
              className="w-100 round"
              color={formValue["package_type_id"] === 2 ? "primary" : "inherit"}
              size="small"
              onClick={() => handleButton("package_type_id", 2)}
            >
              دائمی
            </Button>
          </Grid>
          {formErr && (
            <Grid item xs={12}>
              <Typography className="textError">
                {formErr["package_type_id"]}
              </Typography>
            </Grid>
          )}
        </Grid>
      )}

      <Grid container>
        <Grid item xs={12}>
          <Button
            variant="contained"
            className="w-100 round-btn IBuyButton"
            size="large"
            color="primary"
            type="button"
            onClick={() => validate(handleSubmit)}
          >
            انتخاب نوع بسته
          </Button>
          <CModal
            open={modal}
            onClose={handleClose}
            onAgree={handlePackage}
            agreeText="انتخاب"
          >
            {/* @ts-ignore */}
            <Box className="modal-header mb-3" justifyContent="center">
              <Typography className="text-center text-white">
                لیست بسته ها
              </Typography>
            </Box>
            <div className="container mb-2">
              <div className="container innerModal">
                <div className="select">
                  <div
                    // variant="contained"
                    className={
                      arrayEquals(filtered, [1]) ? "IButtonActive" : "IButton"
                    }
                    style={{
                      margin: "0px 5px",
                      borderRadius: "10px",
                      width: "100%",
                    }}
                    onClick={() => filter([1])}
                  >
                    روزانه
                  </div>
                  <div
                    // variant="contained"
                    className={
                      arrayEquals(filtered, [7]) ? "IButtonActive" : "IButton"
                    }
                    style={{
                      margin: "0px 5px",
                      borderRadius: "10px",
                      width: "100%",
                    }}
                    onClick={() => filter([7])}
                  >
                    هفتگی
                  </div>
                  <div
                    // variant="contained"
                    className={
                      arrayEquals(filtered, [30, 60, 90, 120, 180])
                        ? "IButtonActive"
                        : "IButton"
                    }
                    style={{
                      margin: "0px 5px",
                      borderRadius: "10px",
                      width: "100%",
                    }}
                    onClick={() => filter([30, 60, 90, 120, 180])}
                  >
                    ماهانه
                  </div>
                  <div
                    // variant="contained"
                    className={
                      arrayEquals(filtered, [365]) ? "IButtonActive" : "IButton"
                    }
                    style={{
                      margin: "0px 5px",
                      borderRadius: "10px",
                      width: "100%",
                    }}
                    onClick={() => filter([365])}
                  >
                    سالانه
                  </div>
                </div>
                {/* @ts-ignore */}
                <Box
                  display="flex"
                  justifyContent="center"
                  className="table-res"
                >
                  <table className="table table-striped table-borderless">
                    <thead>
                      <tr>
                        <th style={{ width: '50%' }}>نام بسته</th>
                        <th>نوع بسته</th>
                        <th>مبلغ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allPacks
                        ?.filter(
                          (p: any) =>
                            parseInt(p?.package_type) ===
                            formValue["package_type_id"]
                        )
                        ?.map((pack: any) => {
                          return (
                            <tr
                              onClick={() => handleChoose(pack)}
                              className={
                                info?.package_id == pack?.package_id
                                  ? "tr-active"
                                  : ""
                              }
                            >
                              <td>{pack.title}</td>
                              <td>{pack.title_package_type}</td>
                              <td>{RialSeparator(pack.bill_amount)} ریالی</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </Box>
              </div>
            </div>
          </CModal>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InternetView;
